export default {
    namespaced: true,
    users: {
        title: "Usuario | Usuarios",
        email: "correo",
        username : "usuario",
        name: "nombres",
        first_name: "primer apellido",
        second_name: "segundo apellido",
        last_name: "apellidos",
        password: "contraseña",
        phone_number: "número telefónico",
        active: "activo",
        vpn_access: "acceso por vpn",
        last_login: "último inicio de sesión",
        alarms_history: "historial de alarmas",
        allowed_units_live_video_flows: "flujos de video permitidos",
        alarm_history_per_hours: "horas permitidas de historial alarmas",
        alarm_history_per_days: "días permitidos de historial alarmas",
        alarm_history_by_records: "registros permitidos de historial alarmas",
        plate_number: "no. de placa o no. de empleado",
        allowed_tabs: "tabs permitidas",
        shared_tenants: "tenants compartidos",
        video_wall: "video wall",
        info: "info",
        saving_info: "guardando la información",
        enabled_chat: "chat habilitado",
        enabled_helpdesk: "helpdesk habilitado",
        id_country: "id del país",
        set_password: {
            title: "Asignar contraseña",
            password: "Ingresa tu contraseña",
            password_retype: "Confirma tu contraseña",
            password_rules: "Ingrese su nueva contraseña para obtener acceso a la plataforma SBO. Recuerda que debe tener al menos 8 caracteres, con una letra mayúscula, una letra minúscula, un número y un carácter especial."
        },
        expired_link: "Enlace caducado",
        generate_link: "Generar enlace",
        send_link_email: "Enviar enlace por correo electrónico",
        reset_password: "Restablecer contraseña",
        belogs_user: "El usuario pertenece al grupo ",
        reset_password_no_email: "Asignar contraseña",
        search_leader: "Buscar líder...",
        search_users: "Buscar usuarios...",
        search_filters: {
            soeid: "SOEID",
            email: "E-mail",
            name: "Nombre",
            first_name: "Apellido paterno",
            second_name: "Apellido materno",
            phone_number: "Número telefónico",
        },
    },
};
